export default __webpack_public_path__ + "static/media/rocket.2702d103.svg";